// extracted by mini-css-extract-plugin
module.exports = {"layout":"iz","content":"iA","footer":"iB"};